import i18n from "@/configs/i18n";

export const TokenTransformRequest = (data, headers) => {
  const token = localStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return data;
};

export const LocaleTransformRequest = (data, headers) => {
  if (i18n.global.locale?.value)
    headers["Accept-Language"] = i18n.global.locale.value;
  return data;
};
